import { IconButton } from '@backyard-ui/core';
import { ChevronLeft, ChevronRight } from '@backyard-ui/icons';

import { navigationButtonStyles } from './NavigationButton.styles';

type NavigationButtonProps = {
  direction: 'left' | 'right';
  onClick: () => void;
};

const NavigationButton = (props: Readonly<NavigationButtonProps>) => {
  const { direction, onClick } = props;

  return (
    <div className={navigationButtonStyles({ direction })}>
      <IconButton
        size="xs"
        variant="ghost"
        appearance="neutral"
        icon={direction === 'left' ? <ChevronLeft /> : <ChevronRight />}
        onClick={onClick}
      />
    </div>
  );
};

export default NavigationButton;
